// extracted by mini-css-extract-plugin
export default {"overlay":"ePFDeP1h","text":"mll8FxTe"};